import { useState } from "react";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import calculateAddOnGiftAmount from "../../calculateAddOnGiftAmount";

const ctfData = window?.data?.paymentPageData?.ctfData || {};

const useAddOnGiftAmountCalculation = (addOnGift) => {
  const {
    state: { amount, addOnAmounts, paymentMethods, selectedPaymentMethodID },
  } = usePaymentPage();
  const [inputAmountUpdated, setInputAmountUpdated] = useState(false);
  const { addOnID, type, presetAmount } = addOnGift;

  const determineInitialAmountByType = () => {
    switch (type) {
      case "flat":
        return inputAmountUpdated ? null : presetAmount;
      default: {
        const selectedPaymentMethod = paymentMethods.find(
          (p) => p.ID === selectedPaymentMethodID
        );
        const calculatedAmount = calculateAddOnGiftAmount(
          amount,
          addOnAmounts,
          addOnGift,
          ctfData,
          selectedPaymentMethod?.paymentType
        );
        return calculatedAmount;
      }
    }
  };

  const found = addOnAmounts.find((a) => a.addOnID === addOnID);
  const foundAmount = found?.amount || null;

  return {
    displayAmount:
      type === "ctf"
        ? determineInitialAmountByType() || null
        : foundAmount || determineInitialAmountByType() || null,
    inputAmountUpdated,
    setInputAmountUpdated,
  };
};

export default useAddOnGiftAmountCalculation;
